import React from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import intl from "react-intl-universal";

const useStyles = makeStyles(() => ({
  textStatus: {
    textAlign: "right",
  },
}));

export const VideoStatusBar = () => {
  const classes = useStyles();
  return (
    <Box mt={1} className={classes.textStatus}>
      {`${intl.get("WITHBALL_VIDEO_TIME")}0:00/0:00 ${intl.get(
        "WITHBALL_MATCH_TIME"
      )} 1970/01/01 00:00:00`}
      <Box display="inline" mr={1} />
      <Button variant="outlined" size="small">
        {intl.get("WITHBALL_DATETIME_SYNC_BUTTON")}
      </Button>
    </Box>
  );
};
